let wh = {};
import vue from '../../main';

wh.imgSrc = (function (){
    var list = [2,4,5,6,7,8,9,10,11,12,13,14,15,
                16,17,18,19,20,21,22,23,24,25,26,
                27,28,29,30,31,32,33,34,35,36,37,
                38,39,40,41,42,43,44,45,46,47,48,
                49,50,51,52,53,54,55,56,57,58,59,
                61,62,63,64,65,66,67,68,69,70,73,
                74,75,76,77,79,81,82,83,86,87,90,
                91,97,98,99,100,107,116,117,115,118]; 
    let night = {},
        day = {},
        target = {};
    list.forEach(element => {
        night[element] = require('../../../public/img/SourceIcon/night/' + element + '@3x.png');
        day[element] = require('../../../public/img/SourceIcon/day/' + element + '@3x.png');
        target[element] = true;
    });
    function is_exist (_id) {
        return target[_id];
    }
    return {
        night,
        day,
        is_exist
    }  
})();

// 未完
wh.axios = (_obj) => {
    this.axios({
        method: _obj.method,
        url: _obj.url,
        data: _obj.data,
        headers: {
            'Authorization': 'Basic ' + btoa(cookies.get('username') + ':' + cookies.get('password'))
        }
    }).then((_result)=>{

    }).catch((err)=>{
        
    })
}

wh.bridge = (params) => {
    console.log(params.class+','+params.method)
    cordova.exec(params.callback,function (err) {
        console.log(err)
        params.callback("Nothing to echo")
    }, params.class, params.method, params.param ? [params.param] : [''])
};

wh.onceTriggerItrt = (() => {
    var _itrtStore = {};
    return function (params) {
        if (!(params.class && params.method)) {
            console.log("params's class name or method name is undefined")
            return;
        }
        if (_itrtStore[params.class] && _itrtStore[params.class][params.method]) return;
        if (!_itrtStore[params.class]) {
            _itrtStore[params.class] = {}
        }
        _itrtStore[params.class][params.method] = true;
        cordova.exec(params.callback,function (err) {
            console.log(err)
            params.callback("Nothing to echo")
        }, params.class, params.method, params.param ? [params.param] : [''])
    }
}) ();
// TODO: 做生成交互的高阶函数interaction
wh.interactionList = (function () {
    var once_queue = [];
    var repeat = null;
    var _res = null;
    function bridge () {
        //调用cordova交互
        cordova.exec(function (res) {
            console.log('list交互，返回的内容（方法内部打印的）'+ JSON.stringify(res))
            while (once_queue.length > 0) {
                once_queue.pop()(res)
            }
            repeat && repeat(res)
            _res = res
            
        },function (err) {
            console.log(err)
        }, 'NewsListWebPlugin', 'list', [''])
    }
    return {
        callOnce (callback) {
            (once_queue.length == 0 && repeat === null) && bridge();
            if (_res === null) {
                once_queue.push(callback);
            } else {
                setTimeout(()=>{
                    callback(_res)
                },0)
            }
        },
        callRepeat (callback) {
            (once_queue.length == 0 && repeat === null) && bridge();
            repeat = callback;
        }
    }
})()
wh.interactionInfo = (function () {
    var once_queue = [];
    var repeat = null;
    var _res = null;
    function bridge () {
        //调用cordova交互
        cordova.exec(function (res) {
            console.log('info交互，返回的内容（方法内部打印的）'+ JSON.stringify(res))
            while (once_queue.length > 0) {
                once_queue.pop()(res)
            }
            repeat && repeat(res)
            _res = res
            
        },function (err) {
            console.log(err)
        }, 'InteractiveBasePlugin', 'info', [''])
    }
    return {
        callOnce (callback) {
            (once_queue.length == 0 && repeat === null) && bridge();
            if (_res === null) {
                once_queue.push(callback);
            } else {
                setTimeout(()=>{
                    callback(_res)
                },0)
            }
        },
        callRepeat (callback) {
            (once_queue.length == 0 && repeat === null) && bridge();
            repeat = callback;
        }
    }
})()
wh.interactionTheme = (function () {
    var once_queue = [];
    var repeat = null;
    var _res = null;
    function bridge () {
        //调用cordova交互
        cordova.exec(function (res) {
            console.log('主题交互，返回的内容（方法内部打印的）'+ JSON.stringify(res))
            while (once_queue.length > 0) {
                once_queue.pop()(res)
            }
            repeat && repeat(res)
            _res = res
            
        },function (err) {
            console.log(err)
        }, 'InteractiveBasePlugin', 'theme', [''])
    }
    return {
        callOnce (callback) {
            (once_queue.length == 0 && repeat === null) && bridge();
            if (_res === null) {
                once_queue.push(callback);
            } else {
                setTimeout(()=>{
                    callback(_res)
                },0)
            }
        },
        callRepeat (callback) {
            (once_queue.length == 0 && repeat === null) && bridge();
            repeat = callback;
        }
    }
})()

wh.interactionAuth = (function () {
    var once_queue = [];
    var repeat = null;
    var _res = null;
    function bridge () {
        //调用cordova交互
        cordova.exec(function (res) {
            console.log('主题交互，返回的内容（方法内部打印的）'+ JSON.stringify(res))
            while (once_queue.length > 0) {
                once_queue.pop()(res)
            }
            repeat && repeat(res)
            _res = res
            
        },function (err) {
            console.log(err)
        }, 'InteractiveBasePlugin', 'auth', [''])
    }
    return {
        callOnce (callback) {
            (once_queue.length == 0 && repeat === null) && bridge();
            if (_res === null) {
                once_queue.push(callback);
            } else {
                setTimeout(()=>{
                    callback(_res)
                },0)
            }
        },
        callRepeat (callback) {
            (once_queue.length == 0 && repeat === null) && bridge();
            repeat = callback;
        }
    }
})()

wh.customAuth = (function () {
    var _username = undefined;
    var _password = undefined;
    function bridge (callback) {
        cordova.exec(function (res) {
            console.log('主题交互，返回的内容（方法内部打印的）'+ JSON.stringify(res))
            if (res.username != _username && res.password != _password) {
                callback(res);
                _username = res.username;
                _password = res.password;
            }
            
        },function (err) {
            console.log(err)
        }, 'InteractiveBasePlugin', 'auth', [''])
    }
    return {
        bridge
    }
}) ()
wh.head = function (_url) {
    if (_url == '') {
        return '/static/uploads/default_head.png';
    } else {
        return _url + '_0.jpg';
    }
};

wh.decorateTime = function (_start, _stop) {

    /**
     *     [info]时间修饰[info]
     *
     *     [param]开始时间，结束时间[param]
     */

    function timeWrap(_value) {
        if (_value < 10) {
            return '0' + _value;
        } else {
            return _value;
        }
    }

    function formateDate(_date) {
        return timeWrap(_date.getHours()) + ':' + timeWrap(_date.getMinutes()) + ':' + timeWrap(_date.getSeconds());
    }

    function validate(s_date, e_date) {
        //alert(s_date.getFullYear() +' ' + s_date.getMonth() + ' ' + s_date.getDate() + '\n' + e_date.getFullYear() +' ' + e_date.getMonth() + ' ' + e_date.getDate());
        return s_date.getFullYear() == e_date.getFullYear() && s_date.getMonth() == e_date.getMonth() && s_date.getDate() == e_date.getDate();
    }

    var end = _stop - _start;

    var this_date = new Date(),
        now_date = new Date(),
        tomorrow_date = new Date();
    this_date.setTime(_start * 1000);
    tomorrow_date.setTime((_start + 86400) * 1000);
    now_date.setTime(_stop * 1000);

    //error
    if (end <= 0) {
        return '刚刚';
    }

    //today
    if (validate(this_date, now_date)) {
        return '今天 ' + formateDate(this_date);
    }

    //yesterday
    if (validate(tomorrow_date, now_date)) {
        return '昨天 ' + formateDate(this_date);
    }

    return this_date.getFullYear() + '-' + (this_date.getMonth() + 1) + '-' + this_date.getDate() + ' ' + formateDate(this_date);
};

wh.cache = {
    // 清除数据缓存
    clean: function() {
        if (!localStorage) return;
        var targets = [];

        // 确定需要删除选项
        for (var i = 0; i < localStorage.length; i++) {
            var item = localStorage.key(i);
            if (item.toString().indexOf(field_name) == 0) {
                targets.push(item);
            }
        }

        // 批量删除
        for (var j = 0; j < targets.length; j++) {
            localStorage.removeItem(targets[j]);
        }
    }
};

wh.delayed = (() => {
    let time = null;
    return (call,delay) =>{
        time && clearTimeout(time);
        time = setTimeout(()=>{
            call()	
        },delay);
    }
})();

wh.isDebugger = true;
wh.backQueue = (function () {
    var _queue = [];
    return {
        popMethod: () => {
            _queue.pop();
        },
        pushMethod: (obj) => {
            _queue.push(obj);
        },
        callLast: (callback) => {
            var _method = _queue[_queue.length - 1];
            if (_method &&  _method.back) {
                if (callback) {
                    _method.back(callback);
                } else {
                    _method.back();
                }
                
            }
        },
        length: ()=>{
            return _queue.length
        },
        curentInCircle: () => {
            return _queue[_queue.length - 1].inCircle
        },
        clearQueue: ()=>{
            _queue.length = 0;
        }
    }
}) ();

wh.news_loader = () => {
    var arr = [];
    var num = 0;
    return  {
        begin:()=> {
            num += 1;
        },
        execute: (_call) => {
            num -= 1;
            arr.push(_call);
            if((arr.length-1) == num){
                _call();
            }
            arr.shift();
        }
    }
}

wh.loading_loader = () => {
    var flag = true;
    return  {
        execute: (_call) => {
            if (flag) {
                _call();
            }
        },
        finish: (_call) => {
            _call();
            flag = false;
        }
    }
}


wh.app_version = function(_old_version) {
    var version = vue.$route.query.ver 

    var old_version = '';

    if (_old_version && version) {
        old_version = _old_version;
    } else {
        return false;
    }

    return contrast_max(version,old_version);

    // 返回true 说明str版本 >= old_str版本
    function contrast_max (str,old_str) {
        if (str) {
            var place = (str.indexOf('.') > -1) ? str.split('.') : [str],
                old_place = (old_str.indexOf('.') > -1) ? old_str.split('.') : [old_str];
            var max = (place.length < old_place.length) ? old_place.length : place.length;
            for (var i = 0; i < max;i++) {
                if(typeof place[i] == 'undefined'){
                    return false;
                }else if (typeof old_place[i] == 'undefined'){
                    return true;
                }

                if (Number(place[i]) > Number(old_place[i])) {
                    return true;
                } else if (Number(place[i]) < Number(old_place[i])) {
                    return false;
                }
            }

            return true;
        } else {
            return false;
        }
    }
}
export default wh;
